import React, { createContext, useContext, useState } from 'react';

export type Lang = 'pt' | 'es';

const translations = {
  pt: {
    appName: 'noXt networking',
    appSub: 'Configurador de Bastidores',
    homeTitle: 'Encontre o bastidor ideal\npara o seu projeto',
    homeSub: 'Indique as medidas ou capacidade pretendida e o configurador sugere as melhores opções noXt.',
    gamasTitle: 'Gamas disponíveis',
    capacidadeU: 'Capacidade (U)',
    largura: 'Largura (mm)',
    profundidade: 'Profundidade (mm)',
    altura: 'Altura (mm)',
    btnEncontrar: 'Encontrar Bastidor',
    hintCampos: 'Preencha só os campos que conhece — o sistema encontra as melhores opções.',
    erroValor: 'Introduza apenas valores numéricos positivos.',
    semResultado: 'Nenhum bastidor encontrado',
    semResultadoSub: 'Tente ajustar os critérios de pesquisa.',
    voltar: 'Nova pesquisa',
    resultadosTitle: 'Bastidores sugeridos',
    resultadosSub: 'Ordenados por compatibilidade com os seus critérios',
    badgeNCB: '✔ Acessórios incluídos',
    badgeProX: '★ Logo cliente ≥10 unid.',
    badgeCCTV: 'CCTV',
    specsNCB: '18U · 22U · 27U · 37U · 42U  ·  600/800mm L  ·  600/800/1000mm P',
    specsProX: '7U · 9U · 12U · 16U · 20U  ·  600mm L  ·  450/600mm P',
    specsSlim: '580 × 550 × 160mm  ·  Capacidade até 50 kg',
    nomeNCB: 'NCB — Bastidor de Chão',
    nomeProX: 'Rack Mural ProX',
    nomeSlim: 'SlimX — DVR Rack Mural',
    capacidade: 'Capacidade',
    larguraMm: 'Largura (mm)',
    profundidadeMm: 'Profundidade (mm)',
    alturaMm: 'Altura (mm)',
    previo: 'Anterior',
    seguinte: 'Seguinte',
    de: 'de',
    incluido: 'Incluído neste bastidor',
    ncbIncluido: 'Prateleira fixa · Fechadura metálica · Pés de nível ajustáveis · Módulo de ventilação · Régua de energia (PDU) · Kit de rodas',
    proxMsg: 'Com ≥10 unidades, pode personalizar o Rack Mural ProX com o logótipo da sua empresa.',
    acessorios: 'Acessórios opcionais',
    acessoriosSub: 'Adicione acessórios à sua configuração (cada um ocupa 1U)',
    ocupacaoVisual: 'Ocupação visual do bastidor',
    uLivres: 'U livres',
    uUsadas: 'U usadas',
    excede: '⚠ Excede capacidade!',
    resumo: 'Resumo da configuração',
    copiar: 'Copiar referências',
    copiado: '✓ Copiado!',
    pvp: 'PVP s/IVA',
    verProduto: 'Ver produto',
    footer: '© 2026 Contera · noXt Networking · Preços s/ IVA · Sujeitos a alteração sem aviso prévio',
  },
  es: {
    appName: 'noXt networking',
    appSub: 'Configurador de Bastidores',
    homeTitle: 'Encuentre el bastidor ideal\npara su proyecto',
    homeSub: 'Indique las medidas o capacidad deseada y el configurador sugiere las mejores opciones noXt.',
    gamasTitle: 'Gamas disponibles',
    capacidadeU: 'Capacidad (U)',
    largura: 'Ancho (mm)',
    profundidade: 'Profundidad (mm)',
    altura: 'Altura (mm)',
    btnEncontrar: 'Encontrar Bastidor',
    hintCampos: 'Rellene solo los campos que conoce — el sistema encuentra las mejores opciones.',
    erroValor: 'Introduzca solo valores numéricos positivos.',
    semResultado: 'Ningún bastidor encontrado',
    semResultadoSub: 'Intente ajustar los criterios de búsqueda.',
    voltar: 'Nueva búsqueda',
    resultadosTitle: 'Bastidores sugeridos',
    resultadosSub: 'Ordenados por compatibilidad con sus criterios',
    badgeNCB: '✔ Accesorios incluidos',
    badgeProX: '★ Logo cliente ≥10 unid.',
    badgeCCTV: 'CCTV',
    specsNCB: '18U · 22U · 27U · 37U · 42U  ·  600/800mm An  ·  600/800/1000mm P',
    specsProX: '7U · 9U · 12U · 16U · 20U  ·  600mm An  ·  450/600mm P',
    specsSlim: '580 × 550 × 160mm  ·  Capacidad hasta 50 kg',
    nomeNCB: 'NCB — Bastidor de Suelo',
    nomeProX: 'Rack Mural ProX',
    nomeSlim: 'SlimX — DVR Rack Mural',
    capacidade: 'Capacidad',
    larguraMm: 'Ancho (mm)',
    profundidadeMm: 'Profundidad (mm)',
    alturaMm: 'Altura (mm)',
    previo: 'Anterior',
    seguinte: 'Siguiente',
    de: 'de',
    incluido: 'Incluido en este bastidor',
    ncbIncluido: 'Estante fijo · Cerradura metálica · Pies niveladores · Módulo de ventilación · Regleta de energía (PDU) · Kit de ruedas',
    proxMsg: 'Con ≥10 unidades, puede personalizar el Rack Mural ProX con el logotipo de su empresa.',
    acessorios: 'Accesorios opcionales',
    acessoriosSub: 'Añada accesorios a su configuración (cada uno ocupa 1U)',
    ocupacaoVisual: 'Ocupación visual del bastidor',
    uLivres: 'U libres',
    uUsadas: 'U usadas',
    excede: '⚠ ¡Excede capacidad!',
    resumo: 'Resumen de configuración',
    copiar: 'Copiar referencias',
    copiado: '✓ ¡Copiado!',
    pvp: 'PVP s/IVA',
    verProduto: 'Ver producto',
    footer: '© 2026 Contera · noXt Networking · Precios s/ IVA · Sujetos a cambio sin previo aviso',
  },
};

type TranslationKeys = keyof typeof translations.pt;

interface I18nContextType {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: TranslationKeys) => string;
}

const I18nContext = createContext<I18nContextType>({
  lang: 'pt',
  setLang: () => {},
  t: (k) => k,
});

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLang] = useState<Lang>('pt');
  const t = (key: TranslationKeys): string => translations[lang][key] ?? key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
